import { render } from "./SlackMessageReplies.vue?vue&type=template&id=618ff852"
import script from "./SlackMessageReplies.vue?vue&type=script&lang=js"
export * from "./SlackMessageReplies.vue?vue&type=script&lang=js"

import "./SlackMessageReplies.vue?vue&type=style&index=0&id=618ff852&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__